import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  User,
  ImagePlus,
  Heart,
  ShoppingCart,
  ShoppingBag,
  Mail,
  Newspaper,
  Settings,
  Theater,
  Box,
  X,
} from "lucide-react";
import { useSidebar } from "./SidebarContext";
import "../css/Sidebar.css";

/* ----------------------------------------------------------------
   Single source of truth for sidebar links. Add a line here to add
   a link everywhere — no more duplicated markup blocks.
   "My Articles" was the only active link in the original; the rest
   are wired up using the icons that were already imported but
   unused, so they're ready to point at real routes.
   ---------------------------------------------------------------- */

const SIDEBAR_LINKS = [
  { to: "profile", icon: User, en: "Profile", fa: "حساب کاربری" },
  { to: "productlist/manage", icon: ImagePlus, en: "My Items", fa: "آگهی‌های من" },
  { to: "review/bids", icon: Theater, en: "Open Bids", fa: "پیشنهادها" },
  { to: "messages", icon: Mail, en: "Messages", fa: "پیام‌ها" },
  { to: "cart", icon: ShoppingCart, en: "Cart", fa: "سبد خرید" },
  { to: "wishlist", icon: Heart, en: "Wishlist", fa: "علاقه‌مندی‌ها" },
  { to: "review/open-orders", icon: ShoppingBag, en: "My Orders", fa: "سفارش‌ها" },
  { to: "review/my-sales", icon: Box, en: "My Sales", fa: "فروش‌" },
  { to: "community", icon: Newspaper, en: "Community", fa: "فضای گفتگو" },
  { to: "profile/update", icon: Settings, en: "Settings", fa: "تنظیمات" },
];

const tr = (lang, en, fa) => (lang === "en" ? en : fa);

const Sidebar = () => {
  const { lang: routeLang } = useParams();
  const [lang, setLang] = useState("fa");
  const { isOpen, close } = useSidebar();

  useEffect(() => {
    if (routeLang === "fa" || routeLang === "en") {
      setLang(routeLang);
      return;
    }
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setLang(timezone === "Asia/Tehran" ? "fa" : "en");
  }, [routeLang]);

  const dir = lang === "fa" ? "rtl" : "ltr";

  return (
    <>
      {/* backdrop — only present (and clickable) on mobile while open */}
      {isOpen && <div className="av-sidebar-backdrop" onClick={close} />}

      <aside
        className={`av-sidebar ${isOpen ? "is-open" : ""}`}
        dir={dir}
        aria-hidden={!isOpen && undefined}
      >
        <div className="av-sidebar-header">
          <span className="av-sidebar-title">{tr(lang, "Menu", "منو")}</span>
          <button
            type="button"
            className="av-sidebar-close"
            aria-label={tr(lang, "Close menu", "بستن منو")}
            onClick={close}
          >
            <X size={18} />
          </button>
        </div>

        <ul className="av-sidebar-links">
          {SIDEBAR_LINKS.map(({ to, icon: Icon, en, fa }) => (
            <li key={to}>
              <Link to={`/${lang}/${to}`} onClick={close} title={tr(lang, en, fa)}>
                <Icon size={22} />
                <span>{tr(lang, en, fa)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
